module.exports = __webpack_public_path__ + "img/богатство лета 110х90.dd94b097.jpg";